import React from 'react';
import hoistStatics from 'hoist-non-react-statics';
import { connect } from 'react-redux';
import { translations } from '../constants/translations';
import { fetchLocaleFromLocalStorage } from '../utils';

/**
 * A public higher-order component to access translations
 */
const withTranslations = (SourceComponent, ComponentName = 'Component') => {
  function TranslatableComponent({ language, userLogged, ...props }) {
    const translationVersion = fetchLocaleFromLocalStorage() || 'sr';

    const storedLanguage = localStorage.getItem('user')
        ? JSON.parse(localStorage.getItem('user')).language
        : '',
      selectedLanguage = language || storedLanguage || translationVersion;

    return (
      <SourceComponent
        {...props}
        t={translations[selectedLanguage][ComponentName]}
        gt={translations[selectedLanguage].Global}
        enums={translations[selectedLanguage].Enums}
      />
    );
  }

  const mapStateToProps = (state) => ({
    language: state.user && state.user.language,
    userLogged: state.loggedUser && state.loggedUser.loggedUser, //DO NOT RENAME TO 'user' OR 'loggedUser'
  });

  TranslatableComponent.displayName = `withTranslations(${ComponentName})`;

  return hoistStatics(
    connect(mapStateToProps)(TranslatableComponent),
    SourceComponent
  );
};

export default withTranslations;
